import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import { AddMemberToTeamRequest, RemoveMemberFromTeamRequest } from './team-member.types';

export const requestAddMemberToTeam =
  createAction<SagaPayload<AddMemberToTeamRequest>['payload']>('team-member/addMemberToTeam');

export const requestRemoveMemberFromTeam = createAction<SagaPayload<RemoveMemberFromTeamRequest>['payload']>(
  'team-member/removeMemberFromTeam'
);
